const showPassword = document.querySelector('.show-password');

if (null !== showPassword) {
	const inputPassword = document.querySelector('[name="password"]');

	showPassword.onclick = () => {
		if ('password' === inputPassword.getAttribute('type')) {
			inputPassword.setAttribute('type', 'text');
			showPassword.classList.add('show-password--active');
			return;
		}
		inputPassword.setAttribute('type', 'password');
		showPassword.classList.remove('show-password--active');
	};
}
